import { resumeAudio } from './noteSounds';

let ctx: AudioContext | null = null;

function getContext(): AudioContext {
  if (!ctx) ctx = new AudioContext();
  return ctx;
}

export async function playRhythmHit(durationMs: number, accented: boolean): Promise<void> {
  await resumeAudio();
  const audio = getContext();
  const now = audio.currentTime;
  const durationSec = Math.min(Math.max(durationMs / 1000, 0.05), 1.5);

  const osc = audio.createOscillator();
  const gain = audio.createGain();

  osc.type = accented ? 'square' : 'triangle';
  osc.frequency.value = accented ? 180 : 120;

  gain.gain.setValueAtTime(0, now);
  gain.gain.linearRampToValueAtTime(accented ? 0.45 : 0.28, now + 0.008);
  gain.gain.exponentialRampToValueAtTime(0.001, now + durationSec);

  osc.connect(gain);
  gain.connect(audio.destination);
  osc.start(now);
  osc.stop(now + durationSec + 0.02);
}
